import type { Params } from '@feathersjs/feathers'
import type { ClientApplication } from '../../client'
import type { Mail, MailData, MailQuery, MailService } from './mail.class'

export type { Mail, MailData, MailQuery }

export type MailClientService = Pick<MailService<Params<MailQuery>>, (typeof mailMethods)[number]>

export const mailPath = 'mail'

export const mailMethods: Array<keyof MailService> = ['find', 'create']

export const mailClient = (client: ClientApplication) => {
  const connection = client.get('connection')

  client.use(mailPath, connection.service(mailPath), {
    methods: mailMethods
  })
}

declare module '../../client' {
  interface ServiceTypes {
    [mailPath]: MailClientService
  }
}
